import React from "react";
import { Checkbox } from "antd5";
import { Flex, Text } from "styles/utility-components";

export function getFormDirtyValues<T extends Record<string, unknown>>(
  dirtyFields: Record<string, boolean>,
  formValues: T,
): Partial<T> {
  return Object.entries(dirtyFields).reduce<Partial<T>>((acc, [key, isDirty]) => {
    if (isDirty) {
      acc[key as keyof T] = formValues[key as keyof T];
    }
    return acc;
  }, {});
}

type UserOptionProps = {
  id: string;
  checked: boolean;
  icon?: React.ReactNode;
  text: string;
};

export function CheckboxOption({ id, checked, icon, text }: UserOptionProps) {
  return (
    <Flex gap={9} alignItems="center" key={id}>
      <Checkbox checked={checked} />
      {icon && icon}
      <Text fontWeight="500">{text}</Text>
    </Flex>
  );
}
